import { useWindowSize } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Statistic, Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';

export enum StatisticDashboardTypeColor {
  income = '#a0ce33',
  expense = '#cf4a1d',
  info = '#4bbacf',
  authorized = '#e67700',
}

export enum StatisticDashboardModule {
  workOrder = 'WORK_ORDER',
  accountPayable = 'ACCOUNT_PAYABLE',
  accountReceivable = 'ACCOUNT_RECEIVABLE',
}

interface Props {
  tooltipTitle: string;
  statisticTitle: string;
  statisticValue?: string;
  onClick?: VoidFunction;
  color: StatisticDashboardTypeColor;
  dashboardModule: StatisticDashboardModule;
}

const StatisticDashboard: React.FC<Props> = ({
  tooltipTitle,
  statisticTitle,
  statisticValue,
  onClick,
  color,
  dashboardModule,
}) => {
  const { isMobile } = useWindowSize();

  const handlerPermission = () => {
    if (dashboardModule === StatisticDashboardModule.workOrder) {
      return !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_VIEW]);
    } else if (dashboardModule === StatisticDashboardModule.accountReceivable) {
      return !hasPermissions([
        Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_VIEW,
        Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_LAUCH,
      ]);
    } else {
      return !hasPermissions([
        Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
        Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_LAUNCH,
      ]);
    }
  };

  return (
    <>
      <Tooltip title={tooltipTitle} placement={isMobile ? 'bottom' : 'right'}>
        <button
          onClick={onClick}
          className={classNames('header-statistic-action', {
            '--disabled': handlerPermission(),
          })}
        >
          <Statistic
            title={statisticTitle}
            value={statisticValue}
            valueStyle={{ color }}
            style={{ whiteSpace: 'nowrap' }}
          />
        </button>
      </Tooltip>
    </>
  );
};

export default StatisticDashboard;
